import api from './api';

/**
 * Cria uma Unit (revenda) na NerdMonster
 * @param {Object} body - Dados da revenda
 * @param {Object} parameters - Headers e configurações
 */
export const createNerdMonsterUnit = (body, parameters) => {
  return api.post('residential/store/v1/stores/nerdmonster-unit', body, parameters);
};

/**
 * Obtém link SSO da NerdMonster com orquestração automática
 * @param {Object} body - Dados do usuário e revendas
 * @param {Object} parameters - Headers e configurações
 */
export const getNerdMonsterLink = (body, parameters) => {
  return api.post('residential/store/v1/users/me/nerdmonster-link', body, parameters);
};

/**
 * Obtém link SSO da NerdMonster (legado - compatibilidade)
 * @param {Object} parameters - Headers e configurações
 */
export const getNerdMonsterLinkLegacy = (parameters) => {
  return api.get('residential/store/v1/users/me/nerdmonster-link', parameters);
};

